import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};
export function HowItWorks() {
  const steps = [{
    number: '01',
    title: 'CAPTURE',
    description: "Your buses already have cameras and sensors. We work with what's there — no new hardware, no disruption to operations."
  }, {
    number: '02',
    title: 'PROCESS',
    description: 'Our AI watches the patterns, not the people. Every frame is processed on-device, turning raw footage into structured, anonymised data.'
  }, {
    number: '03',
    title: 'STRUCTURE',
    description: 'Boarding counts, dwell times, crowding levels, safety events — all organised by stop, route, and time of day. Ready to query, ready to act on.'
  }, {
    number: '04',
    title: 'DECIDE',
    description: 'Your planning team gets a live intelligence layer. Not more dashboards — clearer decisions, backed by evidence from every journey.'
  }];
  return <section id="how-it-works" className="bg-sure-black w-full py-24 md:py-32 overflow-hidden" data-id="element-102">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="mb-16 md:mb-24" data-id="element-104">
          <h2 className="text-sure-accent text-xs md:text-sm uppercase tracking-widest font-medium mb-4" data-id="element-105">
            How It Works
          </h2>
          <p className="text-sure-white text-2xl md:text-3xl lg:text-4xl font-bold max-w-2xl leading-tight" data-id="element-106">
            From raw video to structured intelligence in four steps.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} className="relative" data-id="element-107">
          {/* Connecting Line (Desktop) */}
          <div className="hidden lg:block absolute top-[28px] left-0 w-full h-[1px] bg-white/10 z-0" data-id="element-108" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 relative z-10" data-id="element-109">
            {steps.map((step, index) => <motion.div key={step.number} variants={itemVariants} className="flex flex-col" data-id="element-110">
                <div className="bg-sure-black inline-flex items-center justify-center w-14 h-14 rounded-full border border-sure-accent text-sure-accent text-lg font-bold mb-6 lg:mb-8" data-id="element-111">
                  {step.number}
                </div>
                <h3 className="text-sure-white text-base md:text-lg font-bold uppercase tracking-widest mb-4" data-id="element-112">
                  {step.title}
                </h3>
                <p className="text-sure-gray text-sm leading-relaxed font-light pr-4" data-id="element-113">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}